/* eslint-disable max-len */
/* eslint-disable security/detect-non-literal-fs-filename */
import React,{useState,useRef,useContext} from 'react'
import { CDN, S3Bucket } from '../../constants'
import { distributorService } from '../../service/distributor.service';
import Spinner from '../../Components/Spinner';
import HeaderContext from '../../Components/Context/HeaderContext';
import { PriceHandler } from '../../redux/helper/CamelCase';
import { AccessPrevilegesFunction } from '../../constants/globalPrivilegesFunction';
import { uploadFileToS3 } from '../../redux/helper/s3Upload';
import { creatUUId } from '../../redux/helper/CreateUUID';


export default function ProfileHeader({HeaderData,handleFetch}) {
    const ref=useRef()
    const [spinner, setspinner] = useState(false)
    // window.Buffer = window.Buffer || require('buffer').Buffer;
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const handleErrorMessage = (message,key)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        handleFetch()
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);

        }, 1000);
    }
    const handleSuccessMessage = (message,key)=>{
        SetSuccessMessage(message);
        
        setspinner('');
        handleFetch()
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
        },1000)
    }

    const handleUploadedFiles = async(val,key)=>{
        const body = {
            "profile_image_url": val
        }
        const res = await distributorService.handleUploadProfile(body);
        if(!res.error && res.data.success_status){
            handleSuccessMessage(res.data.message)
            const user = JSON.parse(localStorage.getItem('user'))
            await distributorService.getSignedUrl(val,'get')
            user.profile.profile_image_url=val;
            localStorage.setItem('user',JSON.stringify(user))
        }else{
            setspinner('')
            handleErrorMessage(res.data.message)

        }
    }


    const handleUpload = async (e, key) => {
        const files = e.target.files;
        setspinner(true);
    
        if (!files || files.length === 0) {
            setspinner(false);
            return;
        }
        try {
            let nameKey = `eub/${creatUUId()}/${files[0].name}`
            const fileUrl = await distributorService.uploadImages(nameKey, files[0])
            const keyPath = fileUrl.split('.com/')[1]; // get the path for storing in backend
            handleUploadedFiles(keyPath, key);
        } catch (err) {
            console.error("S3 Upload Error:", err);
            handleErrorMessage("File upload failed");
        } finally {
            setspinner(false);
        }
    };
    const onBtnClick = () => {
        ref.current.click();
    };

    const handleProfileName=()=>{
        let final=HeaderData?.PARTY_NAME;
        if(HeaderData?.FIRST_NAME !==null && HeaderData?.LAST_NAME !== null){
            final =`${HeaderData?.FIRST_NAME} ${HeaderData?.LAST_NAME}`
        }
        return final
    }
    const [hover, sethover] = useState(false)

    const fetchProductPriceList = async () => {
        const payload = 
        {
            categories:HeaderData.PRODUCT_CATEGORIES,
            export:"excel"
        }
        const productPriceListData = await distributorService.ProductPriceList(payload);
        window.open(productPriceListData.data.data.url, '_blank')
    }

    const privilegesAssigned = AccessPrevilegesFunction('price_list_visibility')

    return (
        <div className="bg-gradient-to-tr from-[#5A585D] to-[#29282B] lg:px-[68px] md:px-[48px] px-5 pt-[15px] pb-[5px]">
            <div className="flex items-center sm:flex-row flex-col ">
                <div className='relative'>
                    <img onMouseEnter={()=>sethover(!hover)} onMouseLeave={()=>sethover(false)} src={HeaderData.profile_image_url?`${CDN}/${HeaderData.profile_image_url}`
                        :"/images/Ellipse7061.png"} alt="icon" className="w-[114px] h-[114px] bg-cover"  style={{borderRadius:'50%',objectFit:'cover'}}/>
                    <input type="file" 
                        onChange={(e)=>handleUpload(e,'attach_po')} 
                        ref={ref}
                        className="opacity-0 absolute top-0 left-0 cursor-pointer w-20 h-5" />
                    <div onClick={()=>onBtnClick()} style={{borderRadius:'50%',background:'#fff',border:'2px solid #eb4631'}} className='w-[25px] h-[25px] absolute top-[70%] right-[0] flex justify-center items-center cursor-pointer'>
                        {!spinner?<img src='/images/Vector.svg' />:<Spinner />}
                    </div>
                </div>
               
                <div>
                </div>
                <div className="pl-6 overflow-auto sm:w-auto w-full">
                    <p className="md:text-xs15 sm:text-xs7 text-lg font-semibold text-[#FFFFFF]">{handleProfileName()}</p>
                    <div className="flex items-center text-[#fff]">
                        <p className="pr-2 sm:text-sm text-xs2 font-normal text-[#FFFFFF]">
                            {HeaderData.ACCOUNT_NUMBER}   
                        </p>
                        |
                        {HeaderData.DISTRIBUTOR_CERTIFICATE !== null && HeaderData.DISTRIBUTOR_CERTIFICATE[0] !== undefined && 
                       
                            <div className="flex items-center text-[#ffffff] px-2" 
                                onClick={()=>{
                                    window.open(`https://${S3Bucket}.s3.amazonaws.com/${HeaderData.DISTRIBUTOR_CERTIFICATE[0]}`, '_blank')}}>
                                <p className="mr-1">Download Certificate </p>
                                <img src="/images/download.png" alt="icon" className=" download-certificate cursor-pointer w-[16px] h-[16px]" /></div>
                        } |
                        {privilegesAssigned &&
                        <div className="flex items-center text-[#ffffff] pl-2" 
                            onClick={()=>{fetchProductPriceList()}}>
                            <p className="mr-1">Download Product Price </p>
                            <img src="/images/download.png" alt="icon" className=" download-certificate cursor-pointer w-[16px] h-[16px]" /></div>
                        }
                    </div>
                    {' '}
                    <div className="pt-4 flex overflow-auto pb-2.5">
                        <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px]">
                            <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Ador Cash</p>
                            <p className="sm:text-lg text-base font-bold text-[#090406] text-end">
                                {`${PriceHandler(HeaderData?.ADOR_CASH_BALANCE || 0)}`}</p>
                        </div>
                        <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px] ml-2.5">
                            <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Credit Limit</p>
                            <p className="sm:text-lg text-base font-bold text-[#090406] text-end">
                                {`${PriceHandler(HeaderData.OVERALL_CREDIT_LIMIT || 0)}`}
                            </p>
                        </div>
                        <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px] ml-2.5">
                            <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Outstanding Amount</p>
                            <p className="sm:text-lg text-base font-bold text-[#090406] text-end">
                                {HeaderData.OUTSTANDING_AMT && `${PriceHandler(HeaderData?.OUTSTANDING_AMT || 0)}`}</p>
                        </div>
                        <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px] ml-2.5">
                            <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Credit Balance</p>
                            <p className="sm:text-lg text-base font-bold text-[#090406] text-end">
                                {HeaderData.OUTSTANDING_AMT && `${PriceHandler(HeaderData?.CREDIT_BALANCE || 0)}`}</p>
                        </div>
                        <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px] ml-2.5">
                            <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Overdue Amount</p>
                            <p className="sm:text-lg text-base font-bold text-[#090406] text-end">
                                {HeaderData.OUTSTANDING_AMT && `${PriceHandler(HeaderData?.TOTAL_OVERDUE_AMT || 0)}`}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}